let increment= 0;

export default (event,data) => {
  let event_data = { event };
  let inc = 0;
  window.dataLayer = window.dataLayer || [];
  console.log("track ",event, data)
  switch(event){
    case "start_button":
      event_data.interaction = increment + 1;
      increment++;
      break;
    case "navigation":
      event_data.page = data.page;
      event_data.interaction = increment + 1;
      increment++;
      break;
    case "location_added":
      event_data.location = data.location;
      event_data.interaction = increment + 1;
      increment++;
      break;
    case "target_added":
      event_data.target = data.target;
      event_data.method = data.method
      event_data.interaction = increment + 1;
      increment++;
      break;
    case "age_added":
      event_data.age_range = data.ageRange;
      event_data.interaction = increment + 1;
      increment++;
      break;
    case "share_link_clicked":
      event_data.interaction = increment + 1;
      increment++;
      break;
    case "get_results":
      event_data.interaction = increment + 1;
      increment++;
      break;
  }
  window.dataLayer.push(event_data);
}




// WEBPACK FOOTER //
// ./src/lib/tracking.js